<template>
          <!--
    ********************************************************
    ****   FORMATO NUMERO 1 LISTA DE VINCULOS           ****
    ****   USADO EN PAGINAS COMO LEYES ESTATALES        ****
    ********************************************************
  -->    
        <ul class="Formato1 row">
         <li class="col-12 col-md-12" :class="columnasContenido(contenido.TamanoDeLaColumna)" v-for="index in contenidos" :key="index.id">
           <a v-if="index.AbrirEnVisor==false" v-on:click="AbrirArchivo(index.RutaArchivoCarpeta,'_self')" >{{index.TextoDelVinculo}}</a>
           <a v-if="index.AbrirEnVisor==true" v-on:click="AbreElVisor(index.RutaArchivoCarpeta)">{{index.TextoDelVinculo}}</a>
           </li>
        </ul>       
</template>

<script>
import comun from "@/../static/js/comun";
export default {
    props:{
    contenidos: Array   
    },
    methods: {
      columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
      },
        AbreElVisor: function(vinculo) {
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
AbrirArchivo: function(vinculo,forma) {
  comun.DescargarDocumentoPDF(vinculo)
           // window.open(vinculo,forma);
        },
    },
    
}
</script>

<style scoped>
.Formato1 a {
    font-size: 17px;
    font-family: 'AntenaBeta';
    color: black;
  }

.Formato1 li {
    padding-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ListaVinculos.vue